import * as angular from "angular";
import {TextTemplatePurposeType} from "../types/text-template-purpose.type";
import {TextTemplateReceiverType} from "../types/text-template-receiver.type";
import {IQService} from "angular";
import {TextTemplatesRequestsService} from "./text-templates-requests.service";

export default class TextTemplatesService {

  constructor(private textTemplatesRequestsService: TextTemplatesRequestsService, private $q: IQService) {
  }

  public getTemplatesByTypeAndCategory(category: TextTemplateReceiverType, purpose: TextTemplatePurposeType, accountId?: string) {
    const deferred = this.$q.defer();

    this.textTemplatesRequestsService.getTemplates(category, accountId)
      .then((unfilteredTemplates) => {

        const filteredTemplates = unfilteredTemplates.filter(template => {
            return purpose == template.textTemplatePurpose;
          }
        )
        deferred.resolve(filteredTemplates);
      })
      .catch((error) => {
        deferred.reject(error);
      })

    return deferred.promise;
  }
}

angular
  .module('bringoz.admin.text-templates')
  .service('textTemplatesService', TextTemplatesService);
